module.exports = __webpack_public_path__ + "img/sign.be7c3526.webp";